import { postForm } from '@/shared/api/client';

export interface ReviewsListParams {
  page: number;
  sort: string;
  id?: string;
  customer_id?: string;
  service_id?: string;
  country_id?: string;
  region_id?: string;
  city_id?: string;
  rating?: string[];
}

export function fetchReviewsList(params: ReviewsListParams) {
  return postForm<Record<string, unknown>>('/bid/review/list/', {
    id: params.id,
    customer_id: params.customer_id,
    service_id: params.service_id,
    page: params.page,
    sort: params.sort,
    country_id: params.country_id,
    region_id: params.region_id,
    city_id: params.city_id,
    rating: params.rating,
  });
}
